import {RblNestResourceInterface} from "../rbl-resource.interface";
import {nString, uNumber, uString, Uuid} from "@hidat/huijs-common";
import {ResourceConfig} from "@hidat/huijs-resource";

export const PlaylistLogItemConfig = new ResourceConfig('PlaylistLogItem', 'playlist_log_items')

export interface PlaylistLogItemInterface extends RblNestResourceInterface {
  name: uString;
  artistName: uString;
  collectionName: uString;

  category: nString;
  //note: nString;

  playlistLogId: Uuid | undefined;
  libraryTitleId: uNumber;
  //primaryAssetUrl: nString
  //secondaryAssetUrl: nString
  //repositoryId: uNumber;
  //secondaryRepositoryId: uNumber;
}
